import { Component, OnInit } from "@angular/core";
import { GeneralService } from "src/app/services/general.service";
import { BulkMessagesService } from "src/app/services/misc/bulk-messages.service";
import { country_codes } from './country-dial-codes';

@Component({
  selector: "app-bulk-messages",
  templateUrl: "./bulk-messages.component.html",
  styleUrls: ["./bulk-messages.component.css"],
})
export class BulkMessagesComponent implements OnInit {
  loading: boolean = false;
  alertClass = `d-none`;
  alertMessage = ``;
  selectedRecipients: any = {};
  form: any;
  _zip_codes = country_codes;
  form_zip: string = '';
  form_recipient: string;
  form_sender: string;
  form_message: string;
  flattened_array = []
  invalid_numbers: Array<any> = [];

  /** INTEGRATIONS */
  is_activated: boolean = false;
  sms_unit_count: number;

  constructor(
    private bulkMessageService: BulkMessagesService,
    private gs: GeneralService
  ) { }

  ngOnInit() {
    this.bulkMessageService.getCompanyIntegrations().subscribe((response: any) => {
      this.is_activated = response ? response.bulkSMS : false;
    });
  }

  addRecipient(event: any, phone_number: string) {
    const last_index = phone_number.trim().length - 1;
    if (event.code && event.code.toLowerCase() === 'enter') {
      const processedNumber = this.processNumber(this.form_zip, phone_number.substring(0, (last_index + 1)));
      if (this.numberIsInvalid(processedNumber.msidn)) {
        this.gs.sweetAlertError(`Enter a valid phone number`);
        return;
      }
      this.selectedRecipients[processedNumber.msidn] = processedNumber;
      this.form_recipient = "";
    }
    if (event.type === 'input' && phone_number[last_index] === ',') {
      const processedNumber = this.processNumber(this.form_zip, phone_number.substring(0, last_index));
      if (this.numberIsInvalid(processedNumber.msidn)) {
        this.gs.sweetAlertError(`Enter a valid phone number`);
        return;
      }
      this.selectedRecipients[processedNumber.msidn] = processedNumber;
      this.form_recipient = "";
    }
  }

  clearForm() {
    this.form_message = '';
    this.form_recipient = '';
    this.form_sender = '';
    this.form_zip = '';
    this.selectedRecipients = {};
  }

  removeRecipient(number: string) {
    delete this.selectedRecipients[number];
  }

  processNumber(zip: string, number: string) {
    let clean_number = "";
    const trimmed_zip = zip.trim();
    const trimmed_number = number.trim();

    if (trimmed_number[0] === "0") {
      clean_number = `${trimmed_zip}${trimmed_number.substr(1)}`;
    } else {
      clean_number = `${trimmed_zip}${trimmed_number}`;
    }

    return {
      msidn: clean_number,
      msgid: clean_number,
    };
  }

  numberIsInvalid(raw_number) {
    const number = raw_number[0] === '+' ? raw_number.substr(1) : raw_number;
    if (isNaN(Number(number)) || number.length > 13) {
      return true;
    }
    return false;
  }
  /**
   * Clean any values left in the form
   */
  processInputResidue() {
    const residue = this.form_recipient;
    const phone_number_list = residue.split(',');
    let processedNumbers = Object.keys(this.selectedRecipients).map(key => this.selectedRecipients[key]);
    phone_number_list.forEach(phone_number => {
      const processedNumber = this.processNumber(this.form_zip, phone_number);
      if (isNaN(Number(processedNumber.msidn))) {
        this.invalid_numbers.push(processedNumber.msidn);
        return;
      }
      processedNumbers.push(processedNumber);
    });
    return processedNumbers;
  }

  flattenSelectedRecipientsIntoArray() {
    let flattened_array = []
    for (let recipient in this.selectedRecipients) {
      flattened_array.push(recipient);
    }
    return flattened_array;
  }

  prepareFormFieldsForSending() {
    let phoneNumbers = this.processInputResidue();
    if (phoneNumbers) {
      return {
        phoneNumbers,
        message: this.form_message.trim(),
        sender: this.form_sender.trim(),
        numberCount: phoneNumbers.length,
      };
    }
  }

  sendMessage() {
    const message = this.prepareFormFieldsForSending();
    this.form = message
    if (message) {
      this.send(message)
    } else {
      this.gs.sweetAlertError(`Kindly Fill The Form`);
    }
  }

  send(message) {
    if (!this.is_activated) {
      this.gs.sweetAlertError(`Bulk SMS not activated`);
      return;
    }

    if (message.numberCount < 1) {
      this.gs.sweetAlertError(`Please enter recipients`);
      return;
    }

    if (!message.message) {
      this.gs.sweetAlertError(`Message cannot be empty `);
      return;
    }

    if (!message.sender) {
      this.gs.sweetAlertError(`Sender cannot be empty`);
      return;
    }

    this.bulkMessageService.getSMSUnit().subscribe((response: any) => {
      this.sms_unit_count = response ? response.units : 0;

      if (message.numberCount > this.sms_unit_count) {
        this.gs.sweetAlertError(`You do not have sufficient SMS units`);
        return;
      }

      if (this.invalid_numbers.length) {
        this.gs.sweetAlertError(`Invalid numbers removed before sending: ${this.invalid_numbers.join()}`);
      }

      this.loading = true;
      this.bulkMessageService.sendMessage(message).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === "SUCCESS") {
            this.gs.sweetAlertSucess("SMS has been sent successfully");
            this.clearForm();
          } else {
            this.gs.sweetAlertError(response.message);
          }
        },
        (error) => {
          this.loading = false;
          this.gs.sweetAlertError(`Could not send message`);
        }
      );
    },
      (error) => {
        this.loading = false;
        this.gs.sweetAlertError(`Error: Failed to fetch SMS units.`);
      });
  }

  displayAlert(code, message) {
    /** code: 0 - error | 1 - success */
    if (code === 0) this.alertClass = `alert-danger`;
    if (code === 1) this.alertClass = `alert-success`;

    this.alertMessage = message;

    setTimeout(() => {
      this.alertClass = `d-none`;
    }, 2000);
  }
}
